import { render, staticRenderFns } from "./DesLCPrint.vue?vue&type=template&id=0fb2f108&scoped=true&"
import script from "./DesLCPrint.vue?vue&type=script&lang=js&"
export * from "./DesLCPrint.vue?vue&type=script&lang=js&"
import style0 from "./DesLCPrint.vue?vue&type=style&index=0&id=0fb2f108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb2f108",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSimpleTable})
